import React, {useState, useEffect, useMemo} from "react";
import {useRecoilState, useRecoilValue} from "recoil";
import {curriculumState} from "../../../../recoil/curriculums/curriculumState";
import DropDownLessonGrade from "./DropDownLessonGrade";
import DropDownLessonChapter from "./DropDownLessonChapter";
import DropDownLesson from "./DropDownLesson";
import DropDownStageType from "./DropDownStageType";
import {classLearningMenuState} from "../../../../recoil/menuState/classLearningMenuState";
import HomeworkBtnReady from "../../../../assets/images/assign_homework_btn.png";
import HomeworkBtnFin from "../../../../assets/images/fin_homework_btn.png";
import {createHomework, makeClass} from "../../../../network/Endpoint";
import {cloneDeep} from "lodash";
import {messageToast} from "../../../../components/Toast";
import {mainClassState} from "../../../../recoil/classes/classesState";
import {lessonStageMenu} from "../../../../recoil/lesson/lessonState";

const CurriculumDropdown = ({ grade, setGrade, semester, setSemester, lessonInfoId, setLessonInfoId, isFirstLoad, setShowTabType, pageType, homeworkStageIds, setHomeworkStageIds, onAssignHomework, setOnAssignHomework, fetchGetClassHomework}) => {
    const curriculumData = useRecoilValue(curriculumState);
    const mainClass = useRecoilValue(mainClassState);
    const [selectedChapter, setSelectedChapter] = useState(null);
    const [selectedLesson, setSelectedLesson] = useState(null);
    const [openDropdown, setOpenDropdown] = useState(null);

    const [stageMenu, setStageMenu] = useRecoilState(lessonStageMenu);

    const [onSelectGrade, setOnSelectGrade] = useState(false);

    const [classLearningMenu, setClassLearningMenu] = useRecoilState(classLearningMenuState);

    // 📌 `lessonInfoId`가 있을 경우 기존 레슨 선택, 없으면 기본값 설정
    useEffect(() => {
        if (!lessonInfoId) return; // lessonInfoId가 없으면 실행 안 함

        const semesterData = curriculumData.lessonSemesterList.find(
            (item) => item.grade === grade && item.semester === semester
        );

        if (semesterData) {
            const chapter = semesterData.lessonChapters.find((ch) =>
                ch.lessons.some((lesson) => lesson.lessonInfoId === lessonInfoId)
            );
            if (chapter) {
                setSelectedChapter(chapter);
                const lesson = chapter.lessons.find((lesson) => lesson.lessonInfoId === lessonInfoId);
                if (lesson) {
                    setSelectedLesson(lesson);
                }
            }
        }
        setShowTabType(0);
    }, [lessonInfoId, grade, semester, curriculumData]);

    // 📌 학년 변경 시, 첫 번째 챕터와 레슨 선택 (단, 처음 로딩 시 실행 안 함)
    useEffect(() => {
        if (!onSelectGrade) return;

        const semesterData = curriculumData.lessonSemesterList.find(
            (item) => item.grade === grade && item.semester === semester
        );

        if (semesterData?.lessonChapters.length > 0) {
            const firstChapter = semesterData.lessonChapters[0];
            setSelectedChapter(firstChapter);

            if (!lessonInfoId) { // lessonInfoId가 설정되지 않은 경우만 업데이트
                setSelectedLesson(firstChapter.lessons[0]);
                setLessonInfoId(firstChapter.lessons[0].lessonInfoId);
            }
        }
    }, [grade, semester]);

    // 📌 챕터 변경 시, 첫 번째 레슨 선택 (처음 로딩 시 실행 안 함)
    useEffect(() => {
        if (isFirstLoad) return;

        if (selectedChapter?.lessons.length > 0) {
            if (!lessonInfoId) { // lessonInfoId가 설정되지 않은 경우만 업데이트
                setSelectedLesson(selectedChapter.lessons[0]);
                setLessonInfoId(selectedChapter.lessons[0].lessonInfoId);
            }
        }
    }, [selectedChapter]);

    const types = useMemo(() => [
        { type: "lesson", typeName: "학교 학습(수업)", page: "/page/classLesson"},
        { type: "homework", typeName: "학교 학습(숙제)", page: "/page/classHomework"},
        { type: "daily", typeName: "오늘의 학습", page: "/page/classDaily"},
    ], []);

    // 숙제 내기 호출
    const assignHomework = () => {
        if(onAssignHomework){   // 숙제 내기 호출
            if(homeworkStageIds.length > 0){
                fetchAssignHomework();
            }
            setOnAssignHomework(false);
        }else{
            setHomeworkStageIds([]);
            setOnAssignHomework(true)
        }
    }

    // 서버에 숙제 저장
    const fetchAssignHomework = async () => {
        try {
            const body = {
                classId: mainClass.classId,
                lessonInfoId: lessonInfoId,
                homeworkDays: 13,
                stageIds : homeworkStageIds
            };
            const res = await createHomework(body);

            const statusCode = res.data.status.code;
            if (statusCode === 'Success') {
                let msgDescription = homeworkStageIds.length+"개의 숙제전송이 완료되었습니다."
                messageToast({message : "숙제 전송 완료", description : msgDescription});
                fetchGetClassHomework();    // 숙제 저장후 현 단원 숙제 정보 다시 가져와서 갱신하기
            } else {
                alert(`ERROR: 숙제 생성중 오류가 발생했어요. \n아크수학으로 문의해 주세요.\n${res.data.status.message}`);
            }
        } catch (error) {
            alert('숙제 생성중 오류가 발생했어요. \n아크수학으로 문의해 주세요.');
        }
    }

    useEffect(() => {
        if(stageMenu){
            setClassLearningMenu(stageMenu.type);
        }else{
            setStageMenu(types[0]);
        }
    }, [setClassLearningMenu, stageMenu]);


    return (
        <div className="flex flex-row w-[1027px] justify-start items-center gap-3">
            <DropDownStageType
                stageMenu={stageMenu}
                setStageMenu={setStageMenu}
                openDropdown={openDropdown}
                setOpenDropdown={setOpenDropdown}
                types={types}
            />
            <DropDownLessonGrade grade={grade} setGrade={setGrade} semester={semester} setSemester={setSemester} openDropdown={openDropdown} setOpenDropdown={setOpenDropdown}   setLessonInfoId={setLessonInfoId} setOnSelectGrade={setOnSelectGrade}/>
            <DropDownLessonChapter
                chapters={curriculumData.lessonSemesterList.find(
                    (item) => item.grade === grade && item.semester === semester
                )?.lessonChapters || []}
                selectedChapter={selectedChapter}
                setSelectedChapter={setSelectedChapter}
                openDropdown={openDropdown}
                setOpenDropdown={setOpenDropdown}
                setLessonInfoId={setLessonInfoId}
            />
            <DropDownLesson
                lessons={selectedChapter?.lessons || []}
                selectedLesson={selectedLesson}
                setSelectedLesson={setSelectedLesson}
                openDropdown={openDropdown}
                setOpenDropdown={setOpenDropdown}
                setLessonInfoId={setLessonInfoId}
            />
            {pageType===types[1].type &&
                (
                    <>
                        <img
                            src={onAssignHomework===true ? HomeworkBtnFin : HomeworkBtnReady}
                            alt="homework assign btn"
                            onClick={() => assignHomework()}
                            className="cursor-pointer"
                        />
                    </>
                )}
        </div>
    );
};

export default CurriculumDropdown;
